import React from 'react'

const React_Coding_Practice_25 = () => {
  return (
    <div>
      <h1>Coding Pratice 25</h1>
    </div>
  )
}

export default React_Coding_Practice_25
